import { Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { StudyTitlesService } from '../../../../ve.service';
import { DataGridTemplate } from '../../../../../../shared/data-grid/data-grid.template';
import { UntypedFormGroup } from '@angular/forms';

export class GaStudyTitlesGridTemplate extends DataGridTemplate {
  editForm: UntypedFormGroup;
  workOrdersService: WorkOrdersService;
  studyTitlesService: StudyTitlesService;
  columns: any[];

  constructor(
    injector: Injector
  ) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.studyTitlesService = injector.get(StudyTitlesService);
    this.editForm = this.workOrdersService.gaAddMultipleForm;
    this.setControls();
    this.setColumns();
    this.selectableSettings.enabled = true;
    this.pageable = false;
    this.gridState.take = null;
    this.filterable = 'menu';
    this.columnMenu = false;
    this.sortable = true;
  }

  read(opts: any): Promise<any> {
    return this.studyTitlesService.read('/includedInTemplate')
    .then(response => {
      return response.filter(i => i.Description !== 'Other');
    });
  }

  create(parentEditDataItem: any): void {
    //this is kept empty on purpose
   }

  edit(dataItem: any): void { 
    //this is kept empty on purpose
  }

  delete(dataItem: any): Promise<any> { return null; }

  save(dataItem: any, isNew: boolean): Promise<any> { return null; }

  private setColumns() {
    this.columns = [
      {
        field: 'Description',
        title: 'Study Title',
        sortable: true,
        filterable: true,
      },
      {
        field: 'CMEAreaDescription',
        title: 'CME Area',
        sortable: true,
        filterable: true,
      }
    ];
  }

  private setControls() {
    this.controls.excel = false;
    this.controls.delete = false;
    this.controls.edit = false;
    this.controls.add = false;
  }
}
